import { createAction, props } from '@ngrx/store';
import { SendNotificationModel } from '../model/sendNotification.interface';

export const sendNotification = createAction(
  '[Send Notifications] Create card notification',
  props<{ notification: SendNotificationModel[] }>()
);
